<template>
  <div class="flex items-center justify-center">
    <div class="width-auth-contents">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.width-auth-contents {
@apply w-full sm:max-w-xl md:max-w-3xl lg:max-w-5xl;
}
</style>
